export default "__VITE_ASSET__afdd1e9b__"